import { Component, OnInit, ElementRef, Sanitizer, Inject, PLATFORM_ID, ChangeDetectorRef } from '@angular/core';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { ActivatedRoute, RouterModule } from '@angular/router';
import { DataServiceService } from 'src/app/services/data-service.service';
import { Article } from 'src/app/models/article';
import { SeoService } from 'src/app/services/seo.service';
import { faEnvelope } from '@fortawesome/free-solid-svg-icons';
import { DomSanitizer } from '@angular/platform-browser';
import { SafePipe } from 'src/app/pipes/safe.pipe';
import { LinkedinComponent } from '../../_components/linkedin/linkedin.component';
import { TwitterComponent } from '../../_components/twitter/twitter.component';
import { FacebookComponent } from '../../_components/facebook/facebook.component';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { ArticleSearchCardComponent } from '../_components/article-search-card/article-search-card.component';

@Component({
    selector: 'app-article-details',
    templateUrl: './article-details.component.html',
    styleUrls: ['./article-details.component.scss'],
    imports:[CommonModule,RouterModule,SafePipe,LinkedinComponent,TwitterComponent,FacebookComponent,FontAwesomeModule]
})
export class ArticleDetailsComponent implements OnInit {

  pageUrl = '';
  tweet = encodeURIComponent(("meta[name='description']")); //.attr("content"));

  articleHeadline: Article
  article: Article = new Article()
  articleLoaded = false;
  articles
  authors: any[] = [];
  faEnvelope = faEnvelope;

  constructor(
    private route: ActivatedRoute, 
    private dataservice: DataServiceService, 
    private seoservice: SeoService, 
    private elementRef:ElementRef, 
    private sanitizer:DomSanitizer, 
    @Inject(PLATFORM_ID) private platformId: Object,
  private cdr: ChangeDetectorRef) {
    if (isPlatformBrowser(this.platformId)) {
      this.pageUrl = encodeURIComponent(document.URL);
    }
  }

  shuffle(array) {
    var currentIndex = array.length, temporaryValue, randomIndex;
  
    // While there remain elements to shuffle...
    while (0 !== currentIndex) {
  
      // Pick a remaining element...
      randomIndex = Math.floor(Math.random() * currentIndex);
      currentIndex -= 1;
  
      // And swap it with the current element.
      temporaryValue = array[currentIndex];
      array[currentIndex] = array[randomIndex];
      array[randomIndex] = temporaryValue;
    }
  
    return array; 
  }

  ngOnInit() {

    this.route.params.subscribe(params => {
// $&(params)
      this.dataservice.getArticleDetails(params.friendlyUrl).subscribe(resp => {
        resp[0].posterUrl = resp[0].posterUrl?resp[0].posterUrl.replace('http://', 'https://').replace("177x100", "512x288"):"https://services.ifa.com/art/images/1640_512x288_c_ifc-generic-article-banner.png"; //fallback to logo image for articles
resp[0].posterUrl = resp[0].posterUrl.replace(/\.(png|jpg|jpeg)$/, "_q80.webp"); // convert to webp for performance
       
        this.article=resp[0];
        this.articleLoaded = true;
        if(resp[0].authors){
          this.authors = resp[0].authors;
        }
        
        this.cdr.detectChanges(); // render the article HTML before hunting for its <script> tags
        setTimeout(() => {
          this.reinsertScripts();
        });

        //console.log(this.article)

        this.seoservice.updateTitle(this.article.title);
        this.seoservice.updateMetaInfo(
          this.article.description,
          this.article.author,
          this.article.keywords
          );

        this.dataservice.getArticle().subscribe(allArticles => {
         
         // if not current article id 
         var articlesWithouthCurrent = allArticles.filter(x=>{ if(x.id !== this.article.id) return x; })

         //console.log("articlesWithouthCurrent",articlesWithouthCurrent)
     
        this.articles= this.shuffle(articlesWithouthCurrent)

        //console.log(" this.articles", this.articles)
         this.cdr.detectChanges();
        
        })

      })

    } )

  }

  socialWindow(url) {
    var left = (screen.width - 570) / 2;
    var top = (screen.height - 570) / 2;
    var params = "menubar=no,toolbar=no,status=no,width=570,height=570,top=" + top + ",left=" + left;
    window.open(url, "NewWindow", params);
  }

  emailCurrentPage() {
    window.location.href = "mailto:?subject=" + document.title + "&body=" + escape(window.location.href);
  }

  socialsharefacebook() {
    var url = "https://www.facebook.com/sharer.php?u=" + this.pageUrl;
    this.socialWindow(url);
  };

  socialsharetwitter() {
    var url = "https://twitter.com/intent/tweet?url=" + this.pageUrl + "&text=" + this.tweet;
    this.socialWindow(url);
  };

  socialsharelinkedin() {
    var url = "https://www.linkedin.com/shareArticle?mini=true&url=" + this.pageUrl;
    this.socialWindow(url);
  }

  reinsertScripts(): void {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }
    //console.log('reinsertScripts')
    // snapshot: executing a script can inject more <script> tags into the live collection
    const scripts: HTMLScriptElement[] = Array.from(
      this.elementRef.nativeElement.getElementsByTagName('script') as HTMLCollectionOf<HTMLScriptElement>
    );
    for (const script of scripts) {
      const scriptCopy = < HTMLScriptElement > document.createElement('script');
      scriptCopy.type = script.type ? script.type : 'text/javascript';
      if (script.innerHTML) {
        scriptCopy.innerHTML = script.innerHTML;
      } else if (script.src) {
        scriptCopy.src = script.src;
      }
      scriptCopy.async = false;
      script.parentNode.replaceChild(scriptCopy, script);
    }
  }

}
